export default __webpack_public_path__ + "static/media/hero-caro-new-1.054eeb82.png";